import React, {Component} from 'react';
import Dashboard from './Dashboard';

/**
 * Component class of HomeApp.
 *
 * @return {string} the compnent conents.
 */
export default class HomeApp extends Component {
  // eslint-disable-next-line require-jsdoc
  constructor(props) {
    super(props);
    this.state = {};
  }

  /**
   * React render function.
   *
   * @return {string} the component contents.
   */
  render() {
    return (
      <div>
        <Dashboard />
      </div>
    );
  }
}
